import { useAppSelector } from "redux-share";
import { conditions } from "../../../../../helpers";
import { ConditionName, IMarkerListIconProps } from "../../../../../interfaces";
import { shallowEqual } from 'react-redux'

const MarkersListIcon = (props: IMarkerListIconProps) => {

    useAppSelector(({ controller: { showMiniPlayer } }) => ({ showMiniPlayer }), shallowEqual);
    useAppSelector(({ videoData: { videoElementSizeInfo, params } }) => ({ videoElementSizeInfo, params }), shallowEqual);

    let icon = <></>;

    if (conditions(ConditionName.isSplusEnvironment)) icon = <i className={`fa-solid fa-list ${conditions(ConditionName.isMiniPlayer) ? "pl-text-[13px]" : "pl-text-[22px]"} pl-text-white pl-cursor-pointer`} {...props} />
    else icon = (
        <svg
            style={{
                width: conditions(ConditionName.isMiniPlayer) ? 13 : conditions(ConditionName.isTouchScreenPortrait) ? 16 : 22,
                height: conditions(ConditionName.isMiniPlayer) ? 14 : conditions(ConditionName.isTouchScreenPortrait) ? 16 : 22,
            }}
            viewBox="0 0 22 22"
            fill="none" xmlns="http://www.w3.org/2000/svg" 
            {...props}
        >
            <rect x="3" y="3" width="4" height="4" rx="1.5" />
            <rect x="3" y="9" width="4" height="4" rx="1.5" />
            <rect x="3" y="15" width="4" height="4" rx="1.5" />
            <rect x="8" y="16" width="11" height="2" rx="1" />
            <rect x="8" y="10" width="11" height="2" rx="1" />
            <rect x="8" y="4" width="11" height="2" rx="1" />
        </svg>
    )

    if (conditions(ConditionName.isComplexPortrait)) icon = (
        <div className="pl-flex pl-items-center pl-gap-[14px] pl-rounded-[20px] pl-text-secondary-700 dark:pl-text-secondary-50 pl-bg-gray-100 dark:pl-bg-dark-3 pl-px-4 pl-py-[7px] pl-cursor-pointer" onClick={props.onClick}>
            {icon}
            <span>نشانگرها</span>
        </div>
    )

    return <>{icon}</>
}

export default MarkersListIcon;